export default __webpack_public_path__ + "static/media/home-page-header-bg-mobile.d31ff86c.png";